module.exports = __webpack_public_path__ + "static/img/culture2.7f0ae047.jpg";